module.exports = __webpack_public_path__ + "assets/img/share.a53ba404.jpg";